import { useEffect, useState } from "react";
import api from "../../lib/api";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  useEffect(() => { api.get("/admin/customers").then((r) => setCustomers(r.data)); }, []);

  return (
    <div data-testid="admin-customers">
      <h1 className="font-serif text-4xl tracking-tight mb-1">Customers</h1>
      <p className="text-ink-soft text-sm mb-8">{customers.length} registered customers</p>

      <div className="border border-line rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-black/[0.03] text-left">
            <tr className="overline text-ink-soft">
              <th className="p-4 font-medium">Name</th>
              <th className="p-4 font-medium">Email</th>
              <th className="p-4 font-medium">Orders</th>
              <th className="p-4 font-medium">Joined</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-line">
            {customers.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-ink-soft">No customers yet.</td></tr>}
            {customers.map((c) => (
              <tr key={c.id} data-testid={`customer-${c.id}`}>
                <td className="p-4 font-serif text-base">{c.name}</td>
                <td className="p-4 text-ink-soft">{c.email}</td>
                <td className="p-4">{c.orders_count}</td>
                <td className="p-4 text-ink-soft">{c.created_at ? new Date(c.created_at).toLocaleDateString("en-IN") : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
